export default __webpack_public_path__ + "media/images/26-12ee15b6f2657c234e3b239209f1ab7c.jpg";